import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Icon, Loading, Small } from "orcs-design-system";
import { StyledToolCallBubble } from "../StyledComponents";
import {
  formatElapsedSeconds,
  formatUserFacingProgressLabel,
} from "../utils/formatUserFacingProgressLabel";

/**
 * Compact progress badge for v3 chat.
 * Shows friendly activity copy + a live elapsed timer while running.
 */
export const ToolBadge = ({
  message,
  // kept for call-site compat; count no longer shown (implementation leakage)
  allToolsCalled: _unusedTools = [],
  currentToolLabel = null,
}) => {
  const isRunning = message.status === "pending";
  const friendly =
    formatUserFacingProgressLabel(currentToolLabel) ||
    (isRunning ? "Working" : null);

  const [elapsedSec, setElapsedSec] = useState(0);

  useEffect(() => {
    if (!isRunning) {
      setElapsedSec(0);
      return undefined;
    }
    const startedAt = Date.now();
    setElapsedSec(0);
    const id = setInterval(() => {
      setElapsedSec(Math.floor((Date.now() - startedAt) / 1000));
    }, 1000);
    return () => clearInterval(id);
    // Reset the clock whenever the activity label changes.
  }, [isRunning, currentToolLabel]);

  const parts = [];
  if (friendly) {
    parts.push(friendly);
  }
  if (isRunning) {
    parts.push(formatElapsedSeconds(elapsedSec));
  }
  const label = parts.join(" · ");

  return (
    <StyledToolCallBubble>
      <Box mr="s">
        {isRunning ? (
          <Loading small mr="s" />
        ) : (
          <Icon icon={["fas", "check-circle"]} />
        )}
      </Box>
      <Small color="mutedText">{label}</Small>
    </StyledToolCallBubble>
  );
};

ToolBadge.propTypes = {
  message: PropTypes.shape({
    status: PropTypes.string,
  }),
  allToolsCalled: PropTypes.array,
  currentToolLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null]),
  ]),
};
